'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwShellTopNav = require('./CwShellTopNav.scss');

var _CwShellTopNav2 = _interopRequireDefault(_CwShellTopNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwShellTopNav = function CwShellTopNav(props) {
  return _react2.default.createElement(
    'div',
    {
      className: _CwShellTopNav2.default.cwShellTopNav,
      style: props.style
    },
    props.children
  );
};

CwShellTopNav.propTypes = {
  children: _propTypes2.default.any,
  /**
   * Allows custom styling
   */
  style: _propTypes2.default.object
};

exports.default = CwShellTopNav;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwshelltopnav/CwShellTopNav.js
// module id = 855
// module chunks = 10